import { render, staticRenderFns } from "./ImgGroup.vue?vue&type=template&id=1d37a1c4&scoped=true"
import script from "./ImgGroup.vue?vue&type=script&lang=js"
export * from "./ImgGroup.vue?vue&type=script&lang=js"
import style0 from "./ImgGroup.vue?vue&type=style&index=0&id=1d37a1c4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d37a1c4",
  null
  
)

export default component.exports